import React from 'react';
import PropTypes from 'prop-types';

import Collapsible from '../Collapsible';

const Filter = ({ id, trigger, children, closeOnOutsideClick, subText, newLabel }) => (
  <Collapsible
    id={id || trigger.toLowerCase()}
    trigger={trigger}
    classParentString='filter'
    closeOnOutsideClick={closeOnOutsideClick}
    subText={subText}
    newLabel={newLabel}
  >
    {children}
  </Collapsible>
);

Filter.defaultProps = {
  children: null,
  closeOnOutsideClick: false,
  id: null,
  subText: null,
  newLabel: false
};

Filter.propTypes = {
  trigger: PropTypes.any.isRequired,
  children: PropTypes.any,
  closeOnOutsideClick: PropTypes.bool,
  id: PropTypes.string,
  subText: PropTypes.string,
  newLabel: PropTypes.bool
};

export default Filter;
